export const STATUS_STYLE = {
  new: { label: "Nouveau", cls: "bg-[#002FA7] text-white", col: "border-[#002FA7]" },
  shortlisted: { label: "Présélection", cls: "bg-[#0EA5E9] text-white", col: "border-[#0EA5E9]" },
  interview: { label: "Entretien", cls: "bg-[#7C3AED] text-white", col: "border-[#7C3AED]" },
  accepted: { label: "Accepté", cls: "bg-[#059669] text-white", col: "border-[#059669]" },
  rejected: { label: "Refusé", cls: "bg-[#E60000] text-white", col: "border-[#E60000]" },
  pool: { label: "Vivier", cls: "bg-[#868E96] text-white", col: "border-[#868E96]" },
};
export const PIPELINE = ["new", "shortlisted", "interview", "accepted", "rejected", "pool"];
export const KIND_BADGE = {
  emploi: { label: "Emploi", cls: "bg-[#002FA7] text-white" },
  business_partner: { label: "Business Partner", cls: "bg-[#FFD700] text-[#0A0A0A]" },
};
export const OFFER_STATUS = {
  draft: { label: "Brouillon", cls: "bg-[#868E96] text-white" },
  published: { label: "Publiée", cls: "bg-[#059669] text-white" },
  closed: { label: "Fermée", cls: "bg-[#0A0A0A] text-white" },
};
export const INTERVIEW_STATUS = {
  scheduled: { label: "Planifié", cls: "bg-[#7C3AED] text-white" },
  done: { label: "Réalisé", cls: "bg-[#059669] text-white" },
  cancelled: { label: "Annulé", cls: "bg-[#868E96] text-white" },
};
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const Badge = ({ cfg, testid }) => (
  <span className={`inline-block text-[9px] uppercase tracking-[0.2em] font-bold px-1.5 py-0.5 ${cfg?.cls || "bg-[#868E96] text-white"}`} data-testid={testid}>{cfg?.label || "—"}</span>
);
